import type { 
  PostFilesData,
  PostFilesResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getFileApiModule(affiliatesApi: AxiosInstance) {
  return {
    postFile(params: PostFilesData['body'], onUploadProgress?: (progressEvent: ProgressEvent) => void) {
      return affiliatesApi.post<PostFilesResponse>('/files', params, { onUploadProgress });
    },

    postFiles(params: PostFilesData['body']) {
      return affiliatesApi.post<PostFilesResponse>('/files', params);
    },
  }
}